import { ProductBlock } from './ProductBlock';

export type { TypeProductBlockProps } from './types';
export default ProductBlock;
